import { createStack } from './stack';
import { State } from './state';
export function createParser(schema, specMap, remark) {
    return (text) => {
        const state = new State(createStack(), schema, specMap);
        state.run(remark, text);
        return state.toDoc();
    };
}
export * from './types';
//# sourceMappingURL=index.js.map